import { render, staticRenderFns } from "./newLayoutsDialog.vue?vue&type=template&id=64592a70&scoped=true&"
import script from "./newLayoutsDialog.vue?vue&type=script&lang=js&"
export * from "./newLayoutsDialog.vue?vue&type=script&lang=js&"
import style0 from "./newLayoutsDialog.vue?vue&type=style&index=0&id=64592a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64592a70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})
